/**
 * 共用工具函數庫
 * 供所有 Template 組件使用，避免重複定義
 */

/**
 * 格式化詳細時間（年月日）
 * @param {Object} detailedTime - { years, months, days }
 * @param {string} language - 'zh' | 'en'
 * @returns {string}
 */
export const formatDetailedTime = (detailedTime, language) => {
  if (!detailedTime) return '';
  const { years, months, days } = detailedTime;
  if (language === 'zh') {
    const parts = [];
    if (years > 0) parts.push(`${years}年`);
    if (months > 0) parts.push(`${months}個月`);
    if (days > 0) parts.push(`${days}天`);
    return parts.join(' ') || '0天';
  } else {
    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? 'year' : 'years'}`);
    if (months > 0) parts.push(`${months} ${months === 1 ? 'month' : 'months'}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
    return parts.join(' ') || '0 days';
  }
};

/**
 * 格式化日期顯示
 * @param {Date} date
 * @param {string} language - 'zh' | 'en'
 * @returns {string}
 */
export const formatDate = (date, language) => {
  if (!date) return '';
  if (language === 'zh') {
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  } else {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
};

/**
 * 取得品牌文字（關係類型標籤）
 * @param {string} anniversaryType
 * @param {string} language
 * @returns {string}
 */
export const getBrandingText = (anniversaryType, language) => {
  const brandingMap = {
    couple:       { zh: '愛情時光',   en: 'Love Journey' },
    'first-meet': { zh: '相識紀念',   en: 'First Meeting' },
    'first-date': { zh: '約會紀念',   en: 'First Date' },
    proposal:     { zh: '求婚紀念',   en: 'Engagement' },
    wedding:      { zh: '結婚紀念日', en: 'Wedding Anniversary' },
    custom:       { zh: '特別紀念',   en: 'Special Memory' }
  };
  return brandingMap[anniversaryType]?.[language] || brandingMap.couple[language];
};